const config = {
  ion_defaultAccessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1OWFiMTkzMC05NGIxLTQxZDctODM5Zi1iYzAzMDBhY2YxNWIiLCJpZCI6Mjk3NjUsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1OTI1NzYwMTB9.fXEcnp1-eSNgueZF0zKAw68Gdcom9z_MrqKJBVCWY3M",

  // vworld_key : '13E0945C-6B52-319C-AAF5-26A1EDF3CB90' //t2ols
  vworld_key: "8C25098A-181A-3316-9E86-0D46BB208292", //ljm
};

export default config;
